export const keyMapping = {
    zoom_in: ['command+plus', 'command+='],
    zoom_out: 'command+-',
    zoom_100: 'command+0',
    zoom_fit: 'command+1',
    crop_design: ['C', 'c'],
    export_to_clipboard: ['command+c'],
    export_to_file: ['command+s']
}
